import { useState } from 'react';
import { getDisplay } from '../../pages/MyProperties/listingDisplay';

function firstAddressLine(listing) {
    const addr = getDisplay(listing).address;
    if (!addr) return 'No address';
    return addr.split(',')[0].trim() || addr;
}

export default function TargetsList({
    listings,
    assignments,
    failedListingIds,
    onDropOnTarget,
    onUnassign,
}) {
    const [dragOverId, setDragOverId] = useState(null);

    if (!listings.length) {
        return (
            <div className="bulk-photos-targets">
                <div className="bulk-photos-tray-label">Drafts · drop a photo on each to assign</div>
                <p className="bulk-photos-empty-note">No drafts to assign photos to.</p>
            </div>
        );
    }

    return (
        <div className="bulk-photos-targets">
            <div className="bulk-photos-tray-label">Drafts · drop a photo on each to assign</div>
            {listings.map((listing) => {
                const photos = assignments[listing._id] ?? [];
                const hasPhotos = photos.length > 0;
                const { name, type } = getDisplay(listing);
                const typeLabel = type || listing.confirmedFields?.type || 'No type';

                return (
                    <div
                        key={listing._id}
                        className={[
                            'bulk-photos-target',
                            hasPhotos ? 'has' : '',
                            failedListingIds.has(listing._id) ? 'save-failed' : '',
                            dragOverId === listing._id ? 'drag-over' : '',
                        ].filter(Boolean).join(' ')}
                        onDragOver={(e) => {
                            e.preventDefault();
                            e.dataTransfer.dropEffect = 'move';
                            if (dragOverId !== listing._id) setDragOverId(listing._id);
                        }}
                        onDragLeave={(e) => {
                            if (e.currentTarget === e.target) setDragOverId(null);
                        }}
                        onDrop={(e) => {
                            e.preventDefault();
                            setDragOverId(null);
                            const photoId = e.dataTransfer.getData('text/photo-id')
                                || e.dataTransfer.getData('text/plain');
                            if (photoId) onDropOnTarget(listing._id, photoId);
                        }}
                    >
                        <div className="bulk-photos-target-meta">
                            <div className="bulk-photos-target-name">{name}</div>
                            <div className="bulk-photos-target-sub">
                                {firstAddressLine(listing)}
                                {' · '}
                                {typeLabel}
                            </div>
                        </div>
                        {hasPhotos ? (
                            <div className="bulk-photos-target-grid">
                                {photos.map((photo) => (
                                    <div key={photo.id} className="bulk-photos-target-photo">
                                        <img src={photo.url} alt="" />
                                        <button
                                            type="button"
                                            className="bulk-photos-target-remove"
                                            aria-label="Remove from this property"
                                            onClick={() => onUnassign(listing._id, photo.id)}
                                        >
                                            −
                                        </button>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="bulk-photos-target-slot">
                                Drop a photo · or
                                <button
                                    type="button"
                                    className="bulk-photos-skip"
                                >
                                    Skip
                                </button>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
